import React, { } from 'react'
import { Grid, TextField, FormHelperText } from '@material-ui/core';
import { Field, ErrorMessage } from 'formik';
import DatePicker from '../DatePicker';
import Observers from '../Observers';
import { useStore } from '../../Store'
import { getErrorProps, getOptions, plotItems, findPlot, observers } from '../../utils'

const VisitDetails = ({ readonly, formik }) => {

  const { plots, settings } = useStore()

  const updateDescription = (value) => {
    const description = (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
    formik.setFieldValue('description', description)
  }

  const show = (name) => {
    const field= settings.visitFields.find(f => f.name === name)
    if (field && field.link && formik.values.extraInfo[field.link.name].match(field.link.matchPattern)) return true
    return false
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField select disabled={readonly} label="telgebied" variant="standard" name="plot" fullWidth {...getErrorProps(formik, "plot")} {...formik.getFieldProps('plot')} >
          {plotItems(plots)}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="bezoekdatum" variant="standard" name="dateStart" fullWidth {...getErrorProps(formik, "dateStart")} component={DatePicker}
          onChange={updateDescription} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="opmerkingen" multiline variant="standard" name="extraInfo.opmerking_bezoek" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.opm_bezoek")} {...formik.getFieldProps('extraInfo.opmerking_bezoek')} />
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="volledig onderzocht?" variant="standard" name="extraInfo.volledigheid_bezoek" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid_bezoek")} {...formik.getFieldProps('extraInfo.volledigheid_bezoek')} >
          {getOptions(settings.lists["volledigheid_bezoek"])}
        </TextField>
      </Grid>

      {show('volledigheid_bezoek_opm') &&
      <Grid item xs={12}>
        <TextField disabled={readonly} label="waarom niet geheel geteld?" variant="standard" name="extraInfo.volledigheid_bezoek_opm" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid_bezoek_opm")} {...formik.getFieldProps('extraInfo.volledigheid_bezoek_opm')} />
      </Grid>
      }

      <Grid item xs={12} >
        <Field disabled={readonly} label="deelnemers" variant="standard" name="observers" options={observers(findPlot(plots, formik.values.plot), formik.values.roles)} fullWidth {...getErrorProps(formik, "observers")} component={Observers} />
        <FormHelperText error><ErrorMessage component="div" name="observers" /></FormHelperText>
      </Grid>
    </Grid>
  )
}


export default VisitDetails